import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ISubscription } from '../contracts/psc-subscription.contract';
import SubscriptionService from '../services/subscription.service';

interface ISubscriptionState {
    subscription: ISubscription | undefined;
    isLoading: boolean;
    errorMessage: string | undefined;
}

const initialState: ISubscriptionState = {
    subscription: undefined,
    isLoading: false,
    errorMessage: undefined
};

const Fetch = {
    Subscribe: createAsyncThunk('subscription/Subscribe', async (_, { rejectWithValue }) => {
        try {
            const res = await SubscriptionService.subscribe();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }),
    Unsubscribe: createAsyncThunk('subscription/Unsubscribe', async (_, { rejectWithValue }) => {
        try {
            const res = await SubscriptionService.unsubscribe();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }),
    GetStatus: createAsyncThunk('subscription/GetStatus', async (_, { rejectWithValue }) => {
        try {
            const res = await SubscriptionService.getStatus();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    })
};

const SubscriptionSlice = createSlice({
    name: 'subscription',
    initialState: initialState,
    reducers: {
        SetErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.errorMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        // SubscribeUser
        builder.addCase(Fetch.Subscribe.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = undefined;
        });
        builder.addCase(Fetch.Subscribe.fulfilled, (state, action: PayloadAction<ISubscription>) => {
            state.subscription = action.payload;
            state.isLoading = false;
            state.errorMessage = undefined;
        });
        builder.addCase(Fetch.Subscribe.rejected, (state, action) => {
            state.subscription = undefined;
            state.isLoading = false;
            state.errorMessage = action.payload?.toString();
        });

        // UnsubscribeUser
        builder.addCase(Fetch.Unsubscribe.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = undefined;
        });
        builder.addCase(Fetch.Unsubscribe.fulfilled, (state, action: PayloadAction<ISubscription>) => {
            state.subscription = action.payload;
            state.isLoading = false;
            state.errorMessage = undefined;
        });
        builder.addCase(Fetch.Unsubscribe.rejected, (state, action) => {
            state.subscription = undefined;
            state.isLoading = false;
            state.errorMessage = action.payload?.toString();
        });

        // GetSubscriber
        builder.addCase(Fetch.GetStatus.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = undefined;
        });
        builder.addCase(Fetch.GetStatus.fulfilled, (state, action: PayloadAction<ISubscription>) => {
            state.subscription = action.payload;
            state.isLoading = false;
            state.errorMessage = undefined;
        });
        builder.addCase(Fetch.GetStatus.rejected, (state, action) => {
            state.subscription = undefined;
            state.isLoading = false;
            state.errorMessage = action.payload?.toString();
        });
    }
});

export const SubscriptionFetch = Fetch;
export const SubscriptionAction = SubscriptionSlice.actions;
export const SubscriptionReducer = SubscriptionSlice.reducer;
